import * as R from 'ramda'
import dataInstallClient from './data/installClient.js'
import viewInstallClient from './view/installClient.js'

export default R.pipe(dataInstallClient, viewInstallClient)
